import React from "react";
import { NavLink } from "react-router-dom";

function LinkComponent({ link, name, active, icon }) {
  return (
    <NavLink
      to={link}
      className={({ isActive }) => {
        const activeState = isActive || active;
        return `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition ${
          activeState
            ? "bg-emerald-50 text-emerald-800 shadow-sm"
            : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
        }`;
      }}
      end={link === "/dashboard"}
    >
      {({ isActive }) => {
        const activeState = isActive || active;
        return (
          <>
            <span
              className={`flex h-5 w-5 shrink-0 items-center justify-center ${
                activeState ? "text-emerald-600" : "text-slate-500"
              }`}
            >
              {icon}
            </span>
            <span>{name}</span>
          </>
        );
      }}
    </NavLink>
  );
}

export default LinkComponent;
